package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
sealed class PayNonceRequestResponse {
    @Serializable
    class Invalid(
        @SerialName("message") val message: String? = null,
        @SerialName("responseCode") val responseCode: String? = null
    ) : PayNonceRequestResponse()

    @Serializable
    @SerialName("device_pending")
    data class Pending(
        val pin: String,
        @SerialName("registrationUrl") val url: String,
    ) : PayNonceRequestResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("device_already_registered")
    class AlreadyRegistered(val message: String) : PayNonceRequestResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    class Failed(val message: String) : PayNonceRequestResponse()

    class RetryFailed : PayNonceRequestResponse()

    class Error(val exception: Throwable) : PayNonceRequestResponse()

    class Timeout(val exception: Throwable) : PayNonceRequestResponse()

    fun <R> fold(
        onInvalid: (Invalid: Invalid) -> R,
        onPending: (Pending: Pending) -> R,
        onAlreadyRegistered: (AlreadyRegistered: AlreadyRegistered) -> R,
        onFailed: (Failed: Failed) -> R,
        onRetryFailed: (RetryFailed: RetryFailed) -> R,
        onError: (Error: Error) -> R,
        onTimeout: (Timeout: Timeout) -> R
    ): R {
        return when (this) {
            is Invalid -> onInvalid(Invalid(this.message, this.responseCode))
            is Pending -> onPending(Pending(this.pin, this.url))
            is AlreadyRegistered -> onAlreadyRegistered(AlreadyRegistered(this.message))
            is Failed -> onFailed(Failed(this.message))
            is RetryFailed -> onRetryFailed(RetryFailed())
            is Error -> onError(Error(this.exception))
            is Timeout -> onTimeout(Timeout(this.exception))
        }
    }
}